/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import React from 'react'
import { dateToStringDate, dateToStringDateWithoutYear } from '../../util/DateString'
import Link from 'react-router-dom/es/Link'
import LocalDate from '../../domain/type/Date'

export default function Date(props) {
  if (!props.children) {
    return <span />
  }

  let showYear = true
  if (props.showYear === false) {
    showYear = false
  }

  let date = null
  if (showYear) {
    date = dateToStringDate(props.children)
  } else {
    date = dateToStringDateWithoutYear(props.children)
  }

  const link = props.link

  if (link && props.children) {
    const localdate = new LocalDate(props.children)
    return (
      <Link style={{ color: '#4DB5F0', borderBottom: '1px solid #4DB5F0' }} to={`${link}/${localdate.toISODate()}`}>
        {date}
      </Link>
    )
  }

  return <span>{date}</span>
}
